$(function () {
  $('a[href^="#"]').click(function () {
    let speed = 500;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top - 130;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  $(window).on('scroll', function () {
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.effect-fade').each(function () {
      var elemPos = $(this).offset().top;
      if (scroll > elemPos - windowHeight) {
        $(this).addClass('effect-scroll');
      }
    });
  })

  $(window).on('load', function () {
    const $jsLineUpBtn = $('.js-line-up-btn');
    const $jsCollection = $('.js-collection');
    const $jsRecommend = $('.js-recommend');
    const $jsReview = $('.js-review');

    $jsLineUpBtn.on('click', function () {
      const target = $(this).data('collection')
      if ($(this).hasClass('active')) {
        return false
      } else {
        $jsLineUpBtn.removeClass('active');
        $(`.js-line-up-btn[data-collection="${target}"]`).addClass('active');
        $jsCollection.removeClass('active');
        $jsCollection.each(function () {
          if ($(this).data('collection') === target) {
            $(this).stop(true, true).fadeIn(300, function () {
              $(this).addClass('active');
            });
          } else {
            $(this).stop(true, true).fadeOut(300);
          }
        })

        $jsRecommend.removeClass('active');
        $jsRecommend.each(function () {
          if ($(this).data('collection') === target) {
            $(this).addClass('active');
          }
        })

        $jsReview.removeClass('active');
        $jsReview.each(function () {
          if ($(this).data('collection') === target) {
            $(this).stop(true, true).fadeIn(300, function () {
              $(this).addClass('active');
            });
          } else {
            $(this).stop(true, true).fadeOut(300);
          }
        })
      }

      const windowWidth = $(window).width();
      let scrollTarget = 0;
      if (windowWidth <= 879) {
        scrollTarget = $('.js-line-up-anchor').offset().top + 50;
      } else {
        scrollTarget = $('.js-line-up-anchor').offset().top + 100;
      }
      $('html, body').animate({ scrollTop: scrollTarget }, 600);
    });
  })

  new Splide('.js-styling-raden', {
    type: 'loop',
    perPage: 1,
    arrows: true,
  }).mount();

  new Splide('.js-styling-urushi', {
    type: 'loop',
    perPage: 1,
    arrows: true,
  }).mount();

  new Splide('.js-styling-haku', {
    type: 'loop',
    perPage: 1,
    arrows: true,
  }).mount();

  gsap.registerPlugin(ScrollTrigger);

  gsap.to({}, {
    scrollTrigger: {
      trigger: ".js-line-up-anchor",
      start: "top top",       // トリガーの top が画面 top に達したら「通過判定の開始」
      onLeave: () => {
        // トリガーが画面上に消えたら active を付ける
        document.querySelector(".js-line-up-flow").classList.add("active");
        document.querySelector(".js-top-scroll").classList.add("active");
      },
      onEnterBack: () => {
        // スクロールで戻ってトリガーが画面に入ってきたら active を外す
        document.querySelector(".js-line-up-flow").classList.remove("active");
        document.querySelector(".js-top-scroll").classList.remove("active");
      },
    }
  });

  $('.js-top-scroll').on('click', function () {
    const windowWidth = $(window).width();
    let target = 0;
    if (windowWidth <= 879) {
      target = $('.js-line-up-anchor').offset().top + 50;
    } else {
      target = $('.js-line-up-anchor').offset().top + 100;
    }
    $('html, body').animate({ scrollTop: target }, 600);
  })
})